import { Component } from "@angular/core";
import { MdDialogRef } from "@angular/material";
import { FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "forgot-password-dialog",
  template: require("./forgot-password-dialog.component.html"),
  styles: [require("./forgot-password-dialog.component.scss")]
})
export class ForgotPasswordDialogComponent {
  public forgotForm = this.fb.group({
    email: ["", Validators.email]
  });

  public constructor(
    public dialog: MdDialogRef<ForgotPasswordDialogComponent>,
    public fb: FormBuilder
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/login/forgot-password-dialog/forgot-password-dialog.component.ts